export default "__VITE_ASSET__33eT4sPg__"